<template>
  <svg :width="size"
       :height="size" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.8262 7.00244C14.2167 6.61192 14.8507 6.61192 15.2412 7.00244L20.3018 12.063C20.692 12.4534 20.692 13.0866 20.3018 13.4771L15.2412 18.5376C14.8507 18.9281 14.2167 18.9281 13.8262 18.5376C13.436 18.1471 13.4359 17.514 13.8262 17.1235L17.2197 13.73H4.51367C3.96139 13.73 3.51367 13.2823 3.51367 12.73C3.51367 12.1777 3.96139 11.73 4.51367 11.73H17.1396L13.8262 8.4165C13.436 8.02604 13.436 7.3929 13.8262 7.00244Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '24',
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
